
import TransCloud from './parts/TransCloud';
import { EVENTS } from '../../../shared/Events';
import ConfigScene from '../../helpers/ConfigScene';

class Transition extends PIXI.Container {
  constructor() {
    super();

    // vars
    this.clouds = [];

    // init
    this.init();
  }

  // --------------------------------------------------------------
  // Init
  // --------------------------------------------------------------

  init() {
    // props
    this.y = ConfigScene.SIZES.SCENE_ACTIVE_HEIGHT;
    this.visible = false;

    // items
    this.setItems();

    // add loop
    aScene.signals.loopCall.add(this.loopUp, this);
    aScene.signals.sceneCallMain.add(this.callMainFc, this);
  }

  // --------------------------------------------------------------
  // Main Call
  // --------------------------------------------------------------

  callMainFc(sgType) {
    switch (sgType) {
      case EVENTS.MOVE_TO_TOWN_END:
      case EVENTS.MOVE_TO_HEAVEN_END:
        this.visible = false;
        break;
      case EVENTS.MOVE_TO_TOWN_START:
      case EVENTS.MOVE_TO_HEAVEN_START:
        this.visible = true;
        break;
      default:
    }
  }

  // --------------------------------------------------------------
  // Items
  // --------------------------------------------------------------

  setItems() {
    this.clouds = aScene.dataPool.transition.clouds.map((data) => {
      return new TransCloud(this, data);
    });
  }

  // --------------------------------------------------------------
  // Loop
  // --------------------------------------------------------------

  loopUp() {
    if (aScene.sceneManager.sceneState === -1) {
      this.clouds.forEach(cloud => cloud.loopUp());
    }
  }
}

export default Transition;



// WEBPACK FOOTER //
// ./src/js/scene/parts/transition/Transition.js